import { AppBar, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	EmptyList,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../common/constants";
import { IResponse, IServerError } from "../../../models/common";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	
	formatDate,
	sortDDLByLabel,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AuthService } from "../../../services";
import { CompanyTD1FormService } from "../../../services/CompanyTD1FormService";
import { DateRange } from "@mui/icons-material";
import { EmployeeService } from "../../../services/EmployeeService";
import FileSaver from "file-saver";
import { IAppState } from "../../../store/reducers";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../models";
import { LookupFieldService } from "../../../services/LookupFieldService";
import { PrimeDataGridWithRowExpansion } from "../../PrimeDataGridWithRowExpansion";
import { TD1ReportDataGridWithColumnToggled } from "./TD1ReportDataGridWithColumnToggled";
import { TD1ReportHeader } from "./TD1ReportHeader";
import { ReportsService } from "../../../services/ReportsService";
import { endOfDay } from "date-fns";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";
import { T4SlipService } from "../../../services/T4SlipService";

export interface ITD1ReportSetupPage { }
const TD1_REPORT_QUERY_KEY = "td1-report";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";

const useTD1Report = (
	runGetListAPICall: boolean,
	clientId: string,
	taxYear: number,
	employee: string,
	provincialFederal: string,
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			TD1_REPORT_QUERY_KEY,
			runGetListAPICall,
			clientId,
			taxYear,
			employee,
			provincialFederal,
			params,
		],
		queryFn: () =>
			ReportsService.getTD1Report(
				runGetListAPICall,
				clientId,
				taxYear,
				employee,
				provincialFederal,
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});

const useGetEmployeeDDLItems = (
	clientId: string,
	taxYear: number
) =>
	useQuery({
		queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
		queryFn: (data) => {
			return T4SlipService.getEmployeeDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});


export const TD1Report: React.FC<ITD1ReportSetupPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const [TD1ReportData, setTD1ReportData] =
		useState<any>(undefined);
	const [runGetListAPICall, setRunGetListAPICall] =
		useState<any>(true);
	const [employeeStatus, setEmployeeStatus] = useState<number>(100);



	// const { isPending: isPendingMaskStatus, data: maskStatus } =
	// 	useGetMaskStatus();

	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const employee = formMethods.getValues("employee");
	const provincialFederal = formMethods.watch("provinceFederal");

	const { isPending, data } = useTD1Report(
		runGetListAPICall,
		clientIdStore,
		taxYear,
		employee,
		provincialFederal,
		queryParams,
		navigateToLogout
	);
	const TD1ListData: any | null = data;
	useEffect(() => {
		if (TD1ListData) {
			setTD1ReportData(TD1ListData);
		}
	}, [TD1ListData]);

	const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
		useGetEmployeeDDLItems(clientId, employeeStatus);
	const TD1ReportDataAPICall = (
		payload: any

	) => {
		const fetchData = async () => {
			setIsLoading(true);
			// setQueryParams({
			// 	search_query: "",
			// 	order_by: "firstName",
			// 	order_direction: "asc",
			// 	page: 1,
			// 	size: 25,
			// });
			try {
				const response: any = await ReportsService.getTD1Report(
					true,
					clientIdStore,
					taxYear,
					employee,
					provincialFederal,
					queryParams,
					navigateToLogout
				);

				if (response) {
					setTD1ReportData(response);
				}
			} catch {
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();
	};

	const onSubmit = (values: any) => {
		// let payload = {
		// 	employee: values.employee,
		// 	provinceFederal: values.provinceFederal
		// }
		TD1ReportDataAPICall(
			{
				employee: values.employee,
				provinceFederal: values.provinceFederal
			}
		);
	};

	const [zeroEmployee, setzeroEmployee] = useState(true);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const {
		isPending: isSubmittingAddRemoveHeaderColumns,
		mutate: submitAddRemoveHeaderColumns,
	} = useMutation({
		mutationFn: ReportsService.getTD1AddRemoveHeaderColumns,
		onSuccess: (res: any | IServerError | IResponse) => {
			if (res.status === 200) {
				return queryClient.invalidateQueries({
					queryKey: [TD1_REPORT_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: res.message
						? res.message
						: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
		},
	});

	useEffect(() => {
		if (submitAddRemoveColumnsHandler) {
			submitAddRemoveHeaderColumns({
				clientId: clientId,
				columns: submitAddRemoveColumnsHandler,
				navigateToLogout: navigateToLogout,
			});
		}
	}, [submitAddRemoveColumnsHandler]);

	const TD1ReporEmployeeDDlItems = useMemo(() => {
		if (employeeDDLItems) {
			if (
				employeeDDLItems &&
				Array.isArray(employeeDDLItems)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(employeeDDLItems).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [employeeDDLItems]);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["td1-report"]);

	const upadtedTD1ListItems = useMemo(() => {
		return (
			TD1ReportData &&
			TD1ReportData.items &&
			TD1ReportData?.items.map((item: any) => ({
				...item,

			}))
		);
	}, [TD1ReportData]);

			const expandedLabels = ["Reports"];
	const enhanceData = (data: any[], ancestorChain: string[] = []): any[] => {
		return data.map((item) => {
			const currentChain = [...ancestorChain, item.label];

		
			const isComplianceUnderReports =
				item.label === "Compliance" && ancestorChain.includes("Reports");

		
			const expandedTD1ReportOrSetupItem =
				item.label === "TD1" &&
				ancestorChain.includes("Reports") &&
				ancestorChain.includes("Compliance");

			const isExpanded =
				expandedLabels.includes(item.label) || 
				isComplianceUnderReports ||
				expandedTD1ReportOrSetupItem;

			return {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items
					? enhanceData(item.items, currentChain)
					: undefined,
				path: expandedTD1ReportOrSetupItem
					? "/reports/compliance/td1"
					: item.path ?? undefined,
			};
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const savePdfAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};

	const onExportButtonClick = async (selectedOption: string) => {
		try {
			setIsLoading(true);
			const response = await ReportsService.exportTD1Report(
				selectedOption,
				clientIdStore,
				taxYear,
				employee,
				provincialFederal,
				queryParams,
			);

			if (response) {
				if (selectedOption === "PDF") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `${clientName}.pdf`;
						savePdfAsFile(response, filename);
					}
				} else if (selectedOption === "XLS") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `${clientName}.xlsx`;
						savePdfAsFile(response, filename);
					}
				} else {
					const fileType =
						selectedOption === "XLS"
							? "application/vnd.ms-excel"
							: "text/csv;charset=utf-8;";
					const fileExtension = selectedOption === "XLS" ? "xls" : "csv";

					const blob = new Blob([response], { type: fileType });
					FileSaver.saveAs(blob, `${clientName}-employee.${fileExtension}`);
				}
			} else {
				console.error("Error: No data received from the server");
			}
		} catch (err) {

			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}

	};

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"TD1 Report"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<TD1ReportHeader
						TD1ReporEmployeeDDlItems={TD1ReporEmployeeDDlItems}
						setStateRunGetListAPICall={(value: boolean) => setRunGetListAPICall(value)}
					/>
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isSubmittingAddRemoveHeaderColumns ||
						isLoading || isPendingEmployeeDDLItems
					}
					testId="td1-report"
				/>
				<TD1ReportDataGridWithColumnToggled
					columns={
						TD1ReportData?.headerColumns
							? TD1ReportData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
						// TD1ReportData?.headerColumns ?? []
					}
					completeHeaderColumnsList={
						TD1ReportData
							&& TD1ReportData
								?.totalHeaderColumns &&
							Object.keys(TD1ReportData.totalHeaderColumns).length !== 0 /// comment for use hardcoded data change later
							? TD1ReportData.totalHeaderColumns
							: {}
						// TD1ReportData?.headerColumns ?? []
					}
					submitAddRemoveColumnsHandler={(value: any) =>
						setSubmitAddRemoveColumnsHandler(value)
					}
					onColumnReorder={(value: any) => setOnColumnReorder(value)}
					rows={
						TD1ReportData && upadtedTD1ListItems
							? upadtedTD1ListItems
							: []
						// TD1ReportData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					// onImportButtonClickedHandler={onImportFileClicked}
					// onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						TD1ReportData && TD1ReportData.total
							? TD1ReportData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search by Name"}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroEmployee(value)
					}
					pageTitle={""}
					onExportButtonClick={onExportButtonClick}
				/>

				{TD1ReportData ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							backgroundColor: "#F7F7F7",

							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					></AppBar>
				) : (
					<></>
				)}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
